<template>
<v-card flat>
    <v-card-title>
      <div>
        <h3 class="subheading">SendGrid Integration</h3>
        <div class="caption grey--text">Please enter the API Key from SendGrid</div>
      </div>
      <v-spacer></v-spacer> 
                <v-btn icon @click="cancelCard"><v-icon>clear</v-icon></v-btn>
    </v-card-title>
    <v-divider></v-divider>
    <v-container grid-list-xl>
          <v-layout class="mt-0" row wrap>                       
            <v-flex class="mt-0" xs12>
              <v-textarea
                auto-grow
                v-model="text"
                label="SendGrid API Key"                
                placeholder="Enter your SendGrid API Key"
                rows="1"
                class="body-1 font-weight-regular"
              ></v-textarea>                                                     
            </v-flex>                        
            </v-layout>                  
        </v-container>
        <v-card-actions class="ma-0">
            <v-spacer></v-spacer>                  
                <v-btn round flat color="primary" @click="cancelCard">Cancel</v-btn>
                <v-btn round flat color="primary" @click="saveCard">Save</v-btn>                
        </v-card-actions>  
        </v-card>
</template>

<script>
export default {
  data(){
    return{
      text:null,
      show1: false,
      password: 'Password'
    }
  },
  methods:{
    saveCard(){  
      let pageid = this.$route.params.page_id  
      let text = this.text
      this.$store.dispatch('aconnectSendgrid', {pageid,text})
      this.text = null
      let status = false
      this.$store.dispatch('aresponsemenuStatusChange',status)
      this.$store.dispatch('afetchIntegrationDetails', pageid)
    },
    cancelCard(){
      this.text = null
      let status = false
      this.$store.dispatch('aresponsemenuStatusChange',status)
    }
  },
  computed:{

  }
}
</script>
